const replaceModelFamily = (modelFamily: string) => {
  if (modelFamily === 'Q4') return 'Q4 e-tron';
  if (modelFamily === 'Q6') return 'Q6 e-tron';
  if (modelFamily === 'SQ6') return 'SQ6 e-tron';
  return modelFamily;
};

export const adjustModelName = (modelName: string, year: number, lang: string) => {
  if (modelName.includes('all-new') && lang === 'fr')
    return `Le tout nouveau Audi ${modelName.replace('all-new', '')} ${year}`;
  return `${year} Audi ${modelName}`;
};

export const adjustBodyType = (initialBody: string, modelName?: string) => {
  if (initialBody.includes('allroad')) return 'allroad quattro';
  if (modelName?.includes('Sportback')) return 'sportback';
  return initialBody;
};

export default replaceModelFamily;
